export const activeFilterFieldClassName = 'rounded-sm bg-primary-lighter';

export const activeFilterInputClassName =
  '!border-2 !border-primary bg-primary-lighter text-text-primary ring-1 ring-primary/30';

export const hasActiveFilterValue = (value: unknown): boolean => {
  if (value == null) return false;

  if (value instanceof Date) {
    return !Number.isNaN(value.getTime());
  }

  if (Array.isArray(value)) {
    return value.some(hasActiveFilterValue);
  }

  if (typeof value === 'boolean') {
    return true;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  if (typeof value === 'object') {
    return Object.values(value).some(hasActiveFilterValue);
  }

  return false;
};
